"use client";

import { useId } from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

import { getToken } from "@/src/helpers/auth";
import { slugify } from "src/utils/string";
import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import styles from "./styles.module.css";

const HeaderMenuSub = ({ isOpen, isUserMenu, data, logout, isAuth, slug }) => {
  const id = useId();

  const wrapperClasses = classNames({
    [styles.wrapper]: true,
    [styles.wrapperOpened]: isOpen,
    [styles.wrapperForUser]: isUserMenu,
  });

  const handleClickMenuItem = (item) => {
    let event = null;
    const selectedMenuItem = data?.child?.find((menuItem) => menuItem?.tradeTypeId === item.tradeTypeId) || null;
    const selectedMenuItemUrl = selectedMenuItem?.url;

    if (item.tradeTypeId) {
      const eventLabel = slugify(selectedMenuItem.name);
      event = `click||${slug}||${eventLabel}`;
    } else {
      event = item.event;
    }

    if (!selectedMenuItemUrl) return;

    Ga4WithEventParameters({
      eventName: "header",
      eventParameters: { label: event },
    });
  };

  return (
    <ul className={wrapperClasses}>
      {data?.child?.map((item, index) => {
        const elementIsLogout = item?.id === "log_out";
        return !elementIsLogout ? (
          <li key={`${id}${index}`}>
            <a
              data-test-selector={item.testSelector}
              href={
                isAuth
                  ? `${window.env.EJ_APPS_PANEL_HOSTNAME}/#/member/authorize?token=${getToken()}&redirectUrl=${
                      item.url
                    }`
                  : `/${item.url}`
              }
              onClick={() => handleClickMenuItem(item)}
              target={isAuth ? "_blank" : "_self"}
              rel="noreferrer"
            >
              {item.name}
            </a>
          </li>
        ) : (
          <li key={`${id}${index}`}>
            <span onClick={logout}>{item?.name}</span>
          </li>
        );
      })}
    </ul>
  );
};

HeaderMenuSub.propTypes = {
  isOpen: PropTypes.bool,
  isUserMenu: PropTypes.bool,
  data: PropTypes.object,
  logout: PropTypes.func,
  isAuth: PropTypes.bool,
  slug: PropTypes.string,
};

export default HeaderMenuSub;
